// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"AdminDashboard_buttonPrimary__TjHrh","redButton":"AdminDashboard_redButton__pVZq+"};